import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const PromotionBlockedModal = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    if (seconds <= 0) {
      history.replace('/promotions');
      return undefined;
    }

    const id = setInterval(() => setSeconds(s => s - 1), 1000);

    return () => clearInterval(id);
  }, [seconds, history]);

  const handleGo = () => history.replace('/promotions');

  return (
    <div className="promotion-modal-overlay">
      <div className="promotion-modal">
        <div className="promotion-modal-header">
          <h2 className="promotion-modal-title">{t('common:promotion_unavailable')}</h2>
        </div>

        <div className="promotion-modal-content">
          <div
            className="promotion-modal-message"
            dangerouslySetInnerHTML={{ __html: t('common:promotion_unavailable_message') }}
          />
        </div>

        <div className="promotion-modal-actions">
          <div className="promotion-modal-actions-container">
            <button
              type="button"
              className="promotion-modal-button promotion-modal-button-primary"
              onClick={handleGo}
            >
              {t('common:go_to_promotions')}
              (
              {seconds}
              )
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionBlockedModal;
